import React from 'react';
import portfolio from '../../data/portfolio';
import BrightlightWorkflowDemo from './BrightlightWorkflowDemo';
import ProjectVisual from './ProjectVisual';
import styles from './SelectedWork.module.css';

function WorkEntry({ item }) {
  const source = item.sourceRecord;
  const link = item.link || source?.link || source?.links?.company || '';
  const description = item.description || source?.description || source?.summary || item.label;
  const status = `${item.status.charAt(0).toUpperCase()}${item.status.slice(1)}`;
  const period = source?.period || `${item.label} · ${status}`;

  return (
    <article className={styles.entry} data-work-entry>
      <div className={styles.entryHeader}>
        <h3>
          {link ? (
            <a href={link} target="_blank" rel="noreferrer">
              {item.title}
            </a>
          ) : (
            item.title
          )}
        </h3>
        <span className={styles.period}>{period}</span>
      </div>
      <p className={styles.description}>{description}</p>
      {item.visual === 'brightlight' ? (
        <BrightlightWorkflowDemo />
      ) : (
        <ProjectVisual media={item.media} />
      )}
      {item.credit ? (
        <p className={styles.credit}>
          <a href={item.credit.href} target="_blank" rel="noreferrer">
            {item.credit.label}
          </a>
        </p>
      ) : null}
    </article>
  );
}

export default function SelectedWork({ items = portfolio.flagships }) {
  const chapters = [
    {
      id: 'work-title',
      title: 'Startup work, in production',
      copy: (
        <>
          Today I&rsquo;m an AI engineer on the Agent Intelligence team at{' '}
          <strong>Sauna by Wordware</strong> (YC S24), teaching an AI coworker to think,
          remember, and act on your behalf. Before that I was the founding engineer and first
          hire at <strong>Minerva</strong> (YC X25), the AI accountant, where I built{' '}
          <strong>Mars</strong>, its AI-native accounting firm for CPG brands, and I shipped AI
          features for <strong>Brightlight Health</strong>, a clinic EMR. Same standard
          throughout: real customers, real stakes.
        </>
      ),
      entries: items.slice(0, 4),
    },
    {
      id: 'work-perception-title',
      title: 'Perception & autonomy',
      copy: (
        <>
          Before startups, my work centered on machines that see: a real-time{' '}
          <strong>vision-language model</strong> that follows repair procedures, the{' '}
          <strong>autonomy stack</strong> for an Indy Autonomous Challenge race car, and
          production <strong>camera intelligence</strong> at Lexius. Trading model quality
          against speed, cost, and failure modes is the part I enjoy most.
        </>
      ),
      entries: items.slice(4),
    },
  ];

  return (
    <section id="work" className={styles.section} aria-labelledby="work-title">
      {chapters.map((chapter) => (
        <div className={styles.chapter} key={chapter.id}>
          <div className="section-heading">
            <h2 id={chapter.id}>{chapter.title}</h2>
            <p>{chapter.copy}</p>
          </div>

          <div className={styles.entries}>
            {chapter.entries.map((item) => (
              <WorkEntry item={item} key={item.id} />
            ))}
          </div>
        </div>
      ))}
    </section>
  );
}
